/**
 * @file cssSupport.js
 * @description 是否支持某个css属性
 */

export default function (attr, value) {
    const el = document.createElement('div');
    if (attr in el.style) {
        el.style[attr] = value;
        return el.style[attr] === value;
    }
    return false;
}
